/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSaveCardSession200ResponseAnyOfClientConfig
 */
export interface CreateSaveCardSession200ResponseAnyOfClientConfig {
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSession200ResponseAnyOfClientConfig
     */
    merchantAccount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSession200ResponseAnyOfClientConfig
     */
    clientKey: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSession200ResponseAnyOfClientConfig
     */
    environment: string;
}

/**
 * Check if a given object implements the CreateSaveCardSession200ResponseAnyOfClientConfig interface.
 */
export function instanceOfCreateSaveCardSession200ResponseAnyOfClientConfig(value: object): value is CreateSaveCardSession200ResponseAnyOfClientConfig {
    if (!('merchantAccount' in value) || value['merchantAccount'] === undefined) return false;
    if (!('clientKey' in value) || value['clientKey'] === undefined) return false;
    if (!('environment' in value) || value['environment'] === undefined) return false;
    return true;
}

export function CreateSaveCardSession200ResponseAnyOfClientConfigFromJSON(json: any): CreateSaveCardSession200ResponseAnyOfClientConfig {
    return CreateSaveCardSession200ResponseAnyOfClientConfigFromJSONTyped(json, false);
}

export function CreateSaveCardSession200ResponseAnyOfClientConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSaveCardSession200ResponseAnyOfClientConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'merchantAccount': json['merchantAccount'],
        'clientKey': json['clientKey'],
        'environment': json['environment'],
    };
}

export function CreateSaveCardSession200ResponseAnyOfClientConfigToJSON(json: any): CreateSaveCardSession200ResponseAnyOfClientConfig {
    return CreateSaveCardSession200ResponseAnyOfClientConfigToJSONTyped(json, false);
}

export function CreateSaveCardSession200ResponseAnyOfClientConfigToJSONTyped(value?: CreateSaveCardSession200ResponseAnyOfClientConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'merchantAccount': value['merchantAccount'],
        'clientKey': value['clientKey'],
        'environment': value['environment'],
    };
}

